import { render, staticRenderFns } from "./CoastalErosion.vue?vue&type=template&id=44798ad7"
import script from "./CoastalErosion.vue?vue&type=script&lang=js"
export * from "./CoastalErosion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports